/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import { AnyAction } from 'redux';

import { ServiceEndpoint } from 'client-code/sls-service-endpoints';

import {
    APP_START,
    IS_APPLICATION_READY,
    OVERRIDE_PLAYBACK_PARAMS,
    SET_PARTNER_BRANDING_IMAGE_URL,
    SET_SLS_GLOBAL_ENDPOINTS,
    TURN_OFF_INITIAL_WELCOME,
    TURN_ON_INITIAL_WELCOME,
    UPDATE_COMMON_INACTIVITY_TIMESTAMP,
} from './appl.types';

export const appStartAction = (): AnyAction => ({
    type: APP_START,
});

export const turnOffInitialWelcomeAction = (): AnyAction => ({
    type: TURN_OFF_INITIAL_WELCOME,
    payload: {
        isWelcomeOn: false,
    },
});

export const turnOnInitialWelcomeAction = (): AnyAction => ({
    type: TURN_ON_INITIAL_WELCOME,
    payload: {
        isWelcomeOn: true,
    },
});

export const overridePlaybackParamsAction = ({ tuningUri, drmUri, errorCode }): AnyAction => ({
    type: OVERRIDE_PLAYBACK_PARAMS,
    payload: {
        isOverrideEnable: true,
        overrideDetails: {
            tuningUri,
            drmUri,
            errorCode,
        },
    },
});

export const setSlsGlobalEndpointsAction = (slsGlobalEndpoints: ServiceEndpoint[]): AnyAction => ({
    type: SET_SLS_GLOBAL_ENDPOINTS,
    payload: {
        slsGlobalEndpoints,
    },
});

export const setPartnerBrandingImageUrlAction = (partnerBrandingImageUrl: string): AnyAction => ({
    type: SET_PARTNER_BRANDING_IMAGE_URL,
    payload: {
        partnerBrandingImageUrl,
    },
});

export const setIsApplicationReadyAction = (isApplicationReady: boolean): AnyAction => ({
    type: IS_APPLICATION_READY,
    payload: {
        isApplicationReady,
    },
});

export const updateCommonInactivityTimeStampAction = (): AnyAction => ({
    type: UPDATE_COMMON_INACTIVITY_TIMESTAMP,
    payload: {
        commonInactivityTimeStamp: Date.now(),
    },
});
